import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from "@angular/core";
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatExpansionPanel } from "@angular/material/expansion";

import { from } from "rxjs";
import { filter } from "rxjs/operators";

import { DffSimpelDialog } from "@dffedb/ui";
import { EntitetStatus } from "@dffedb/util";

import { KomponentTyperDialogComponent } from "../komponent-typer-dialog/komponent-typer-dialog.component";
import { KomponentType } from "../model/komponent-type.model";
import { Komponent } from "../model/komponent.model";

export interface OpretKomponentEventArgs {
    formGroup: UntypedFormGroup;
    komponentType: KomponentType;
}
@Component({
    selector: "komponent-gruppe",
    templateUrl: "./komponent-gruppe.component.html",
    styleUrls: ["./komponent-gruppe.component.scss"]
})
export class KomponentGruppeComponent {
    @Input() public formGroup: UntypedFormGroup;
    @Input() public komponentTyper: KomponentType[];

    @Output() public opret = new EventEmitter<OpretKomponentEventArgs>();
    @ViewChildren(MatExpansionPanel) public expansionPanels: QueryList<MatExpansionPanel>;

    constructor(private readonly dialog: MatDialog, private readonly dffDialog: DffSimpelDialog) {}

    public onOpret(): void {
        const komponentGruppeId = this.formGroup.value.id;
        const komponentTyper = this.komponentTyper.filter((t) => t.gruppe.id === komponentGruppeId);

        this.dialog
            .open(KomponentTyperDialogComponent, { data: { komponentTyper } })
            .afterClosed()
            .subscribe((result: KomponentType) => {
                if (result) {
                    this.opret.emit({ formGroup: this.formGroup, komponentType: result });
                    setTimeout(() => {
                        this.expansionPanels.last.open();
                    });
                }
            });
    }

    public onSlet(event: MouseEvent, komponent: UntypedFormGroup): void {
        event.stopPropagation();
        from(this.dffDialog.openJaNej("Slet komponent", "Ønsker du at slette komponenten?"))
            .pipe(filter((result) => result))
            .subscribe(() => {
                komponent.get("status").setValue(EntitetStatus.Slettet);
                if (komponent.get("id").value === 0) {
                    const komponenter = this.formGroup.get("komponenter") as UntypedFormArray;
                    const index = komponenter.controls.findIndex((k) => k.get("id").value === komponent.get("id").value);
                    komponenter.removeAt(index);
                }
            });
    }

    public get komponenter(): AbstractControl[] {
        return (this.formGroup.get("komponenter") as UntypedFormArray).controls.filter((c) => c.value.status !== EntitetStatus.Slettet);
    }

    public getKomponentType(komponent: Komponent): KomponentType {
        const result = this.komponentTyper.find((t) => t.id === komponent.komponentTypeId);
        return result;
    }
}
